{
  "scheduleDashboard": {
    "title": "Flugplan",
    "alerts": {
      "selectFBO": "Bitte wähle ein FBO aus, um den Zeitplan anzuzeigen."
    },
    "viewModes": {
      "timeline": "Zeitachse",
      "timelineTooltip": "Flüge in einer visuellen Timeline/GANTT-Ansicht anzeigen",
      "table": "Tabelle",
      "tableTooltip": "Flüge in detaillierter Tabellenansicht anzeigen"
    },
    "buttons": {
      "createTrip": "Flug erstellen",
      "bulkImport": "Massenimport"
    },
    "filters": {
      "locationCount": "Gefiltert: {{count}} Standort",
      "statusLabel": "Status",
      "statusOptions": {
        "all": "Alle Status",
        "scheduled": "Geplant",
        "active": "Aktiv",
        "completed": "Abgeschlossen",
        "cancelled": "Abgebrochen",
        "requested": "Angefragt",
        "confirmed": "Bestätigt",
        "tenant-based": "Mandantenbasiert",
        "transient": "Durchreisend",
        "hangar": "Hangar"
      },
      "csrStatusOptions": {
        "all": "Alle Status",
        "requested": "Angefragt",
        "confirmed": "Bestätigt",
        "completed": "Abgeschlossen",
        "cancelled": "Abgebrochen"
      },
      "tailNumberLabel": "Kennz. filtern",
      "tailNumberPlaceholder": "N123AB",
      "showPastTrips": "Vergangene Flüge"
    },
    "errors": {
      "timelineTitle": "Zeitleistenfehler",
      "timelineDescription": "Beim Laden der Zeitleistenansicht ist ein Fehler aufgetreten. Bitte versuche, die Seite zu aktualisieren oder zur Tabellenansicht zu wechseln."
    },
    "emptyState": "Keine Flüge im ausgewählten Zeitraum geplant"
  },
  "scheduleList": {
    "columns": {
      "tailNumber": "Kennzeichen",
      "aircraftModel": "Flugzeugmodell",
      "type": "Typ",
      "arrival": "Ankunft",
      "departure": "Abflug",
      "status": "Status",
      "notes": "Notizen",
      "ownerManager": "Inhaber/Manager",
      "assignment": "Zuweisung",
      "actions": "Aktionen"
    },
    "tooltips": {
      "editTrip": "Bearbeiten"
    },
    "dateRange": "Zeigt Flüge von {{startDate}} bis {{endDate}}",
    "tripCount": "Zeige {{filtered}} von {{total}} Flügen",
    "filters": {
      "tailNumberLabel": "Kennz. filtern",
      "tailNumberPlaceholder": "z. B. N123AB",
      "statusLabel": "Status",
      "statusOptions": {
        "all": "Alle Status",
        "scheduled": "Geplant",
        "active": "Aktiv",
        "completed": "Abgeschlossen",
        "cancelled": "Abgebrochen",
        "requested": "Angefragt",
        "confirmed": "Bestätigt",
        "tenant-based": "Mandantenbasiert",
        "transient": "Durchreisend",
        "hangar": "Hangar"
      },
      "csrStatusOptions": {
        "all": "Alle Status",
        "requested": "Angefragt",
        "confirmed": "Bestätigt",
        "completed": "Abgeschlossen",
        "cancelled": "Abgebrochen"
      }
    },
    "noTripsFound": "Keine Flüge gefunden",
    "bulkActions": {
      "selected": "{{count}} selected",
      "setStatus": "Set Status",
      "assignLocation": "Assign Location",
      "cancel": "Cancel Trips",
      "delete": "Delete",
      "clearSelection": "Clear selection",
      "deleteConfirmTitle": "Delete Selected Trips",
      "deleteConfirmMessage": "Are you sure you want to permanently delete {{count}} trip(s)? This action cannot be undone.",
      "deleteConfirmButton": "Delete",
      "cancelConfirmTitle": "Cancel Selected Trips",
      "cancelConfirmMessage": "Are you sure you want to cancel {{count}} trip(s)? This will set their status to 'cancelled'.",
      "cancelConfirmButton": "Cancel Trips",
      "statusSuccess": "Updated status for {{count}} trips",
      "statusPartial": "Updated {{successCount}} trips ({{failCount}} failed)",
      "deleteSuccess": "Deleted {{count}} trips",
      "cancelSuccess": "Cancelled {{count}} trips",
      "assignSuccess": "Assigned {{count}} trips to {{locationName}}"
    }
  },
  "scheduleTimeline": {
    "tooltip": {
      "location": "Standort: {{name}}"
    },
    "deleteConfirmation": {
      "title": "Ausgewählte Flüge löschen",
      "message": "Möchtest du wirklich {{count}} ausgewählte Flüge löschen? Diese Aktion kann nicht rückgängig gemacht werden.",
      "deleteButton": "Löschen",
      "cancelButton": "Abbrechen"
    }
  },
  "scheduledHangarView": {
    "updating": "Aktualisiert...",
    "addObstacleDialog": {
      "title": "Hindernis hinzufügen",
      "cancelButton": "Abbrechen",
      "doneButton": "Fertig"
    },
    "errors": {
      "noData": {
        "title": "Keine Hangardaten verfügbar",
        "description": "Hangar-Informationen für diesen Zeitraum konnten nicht geladen werden. Versuche, die Seite zu aktualisieren oder einen anderen Zeitraum auszuwählen.",
        "actionLabel": "Neu laden"
      }
    }
  },
  "scheduledRampView": {
    "errors": {
      "noData": {
        "title": "Keine Vorfeld-Daten verfügbar",
        "description": "Ramp-Informationen für diesen Zeitraum konnten nicht geladen werden. Versuche, die Seite zu aktualisieren oder einen anderen Zeitraum auszuwählen.",
        "actionLabel": "Neu laden"
      }
    },
    "addObstacleDialog": {
      "title": "Bewegl. Hindernis hinzufügen",
      "buttons": {
        "cancel": "Abbrechen",
        "done": "Fertig"
      }
    }
  },
  "assignLocationDialog": {
    "title": "Flugzeug zu Standort zuweisen",
    "keepUnassigned": "Nicht zuweisen",
    "current": "Aktuell",
    "sections": {
      "hangars": "Hangars",
      "ramps": "Vorfeld"
    },
    "customTimeRange": "Eigener Zeitraum",
    "fields": {
      "startTime": "Startzeit",
      "endTime": "Endzeit"
    },
    "messages": {
      "noLocationsAvailable": "Keine Standorte für den ausgewählten Zeitraum verfügbar.",
      "unassignedPeriodsWarning": "Nicht zugewiesene Zeiträume werden vor/nach diesem Zeitbereich erstellt"
    },
    "buttons": {
      "cancel": "Abbrechen",
      "assign": "Zuweisen",
      "assigning": "Wird zugewiesen..."
    }
  },
  "tripLocationNavigationDialog": {
    "title": "Flug an anderem Standort",
    "labels": {
      "tripLocation": "REISEZIEL",
      "youreViewing": "DU SIEHST"
    },
    "messages": {
      "unassignedTrip": "Dieser Trip wurde noch keinem Standort zugewiesen.",
      "unassignedExplanation": "Du kannst den Zeitraum sehen, in dem dieser Trip geplant ist, aber es gibt keine Hangar- oder Ramp-Zuweisung.",
      "unassignedPrompt": "Wähle, ob du in deiner aktuellen Ansicht zu diesem Zeitraum springen möchtest.",
      "assignedPrompt": "Wähle, ob du zum Standort des Flugs navigieren oder in der aktuellen Ansicht bleiben möchtest."
    },
    "buttons": {
      "cancel": "Abbrechen",
      "stayIn": "Bleib in {{locationName}}",
      "goTo": "Zu {{locationName}}"
    }
  },
  "currentTimeControl": {
    "labels": {
      "currentTime": "Aktuelle Zeit",
      "viewing": "Ansicht: {{startDate}} - {{endDate}}"
    },
    "buttons": {
      "now": "Jetzt"
    }
  },
  "createTripDialog": {
    "title": {
      "create": "Neuen Flug erstellen",
      "newTripFor": "Neuer Flug für {{tailNumber}}"
    },
    "labels": {
      "ownerManager": "Inhaber/Manager",
      "type": "Typ",
      "status": "Status",
      "searchAircraft": "Suche nach Hersteller und Modell",
      "arrivalDateTime": "Ankunftsdatum & -zeit",
      "departureDateTime": "Abflugdatum & -zeit",
      "notes": "Notizen",
      "noDeparture": "Kein Abflug",
      "required": "*"
    },
    "placeholders": {
      "ownerManager": "z. B. Max Mustermann",
      "notes": "Besondere Anforderungen oder Hinweise..."
    },
    "tenantTypes": {
      "transient": "Durchreisend",
      "base": "Basis",
      "yellowCard": "Basis + Yellow Card"
    },
    "messages": {
      "noScheduledDeparture": "Dieses Flugzeug bleibt auf unbestimmte Zeit am FBO ohne geplanten Abflug.",
      "unassigned": "Das Flugzeug wird zunächst als nicht zugewiesen platziert und kann nach der Erstellung in einem Hangar oder Vorfeldbereich positioniert werden.",
      "autoAssigned": "Dieser Trip wird automatisch dem aktuellen {{locationType}} zugewiesen.",
      "autoAssignedSimple": "Der Trip wird für dieses Flugzeug erstellt und kann nach der Erstellung positioniert werden."
    },
    "buttons": {
      "cancel": "Abbrechen",
      "create": "Flug erstellen"
    },
    "tooltips": {
      "conflict": "Flug kann nicht erstellt werden – Überschneidung mit bestehendem Flug",
      "fillRequired": "Bitte fülle alle Pflichtfelder aus"
    }
  },
  "locationFilter": {
    "label": "Nach Standort filtern",
    "placeholder": "Alle Standorte",
    "groups": {
      "hangars": "Hangars",
      "ramps": "Vorfeld"
    }
  },
  "tripEditForm": {
    "labels": {
      "tailNumber": "Kennzeichen",
      "ownerManager": "Inhaber/Manager",
      "aircraftModel": "Flugzeugmodell",
      "status": "Status",
      "arrival": "Ankunft",
      "departure": "Abflug",
      "notes": "Notizen",
      "noDeparture": "Kein Abflug",
      "required": "*"
    },
    "placeholders": {
      "ownerManager": "Eigentümer- oder Managername eingeben",
      "notes": "Notizen zu diesem Flug hinzufügen..."
    },
    "statuses": {
      "scheduled": "Geplant",
      "active": "Aktiv",
      "completed": "Abgeschlossen",
      "cancelled": "Abgebrochen"
    },
    "messages": {
      "baseTenant": "Basis-Mandant",
      "noScheduledDeparture": "Dieses Flugzeug hat keinen geplanten Abflug",
      "indefiniteStay": "Dieses Flugzeug bleibt auf unbestimmte Zeit am FBO ohne geplanten Abflug."
    },
    "buttons": {
      "cancel": "Abbrechen",
      "save": "Speichern",
      "saving": "Speichern..."
    }
  },
  "simpleBulkUpload": {
    "title": "Mehrere Flüge hochladen",
    "pasteExcel": {
      "title": "Aus Excel einfügen",
      "description": "Kopiere Tripdaten aus Excel (Tail Number, Ankunftsdatum, Abflugdatum) und füge sie unten ein. Für Stammmieter lass die Abflugspalte leer oder verwende no departure. Kopfzeilen sind optional und werden automatisch erkannt und übersprungen.",
      "importButton": "Importieren",
      "importing": "Importiert...",
      "sampleFileButton": "Beispieldatei",
      "rowsReady": "{{count}} Zeilen bereit zum Import"
    },
    "editTrips": {
      "title": "Flüge bearb.",
      "tableHeaders": {
        "tailNumber": "Kennzeichen",
        "aircraft": "Flugzeug",
        "arrivalDate": "Ankunftsdatum",
        "departureDate": "Abflugdatum"
      },
      "addButton": "Neu",
      "selectAircraft": "Flugzeug auswählen",
      "placeholders": {
        "tailNumber": "N123AB"
      },
      "validationErrors": {
        "arrivalBeforeDeparture": "Ankunft muss vor Abflug liegen",
        "departureAfterArrival": "Abflug muss nach Ankunft sein"
      }
    },
    "messages": {
      "autoAssign": "Flüge werden automatisch {{locationName}} zugewiesen",
      "validTripsCount": "{{count}} gültige Flüge"
    },
    "buttons": {
      "cancel": "Abbrechen",
      "save": "{{count}} Flüge speichern"
    },
    "progress": {
      "uploadingTitle": "Lade Trips hoch",
      "uploadingMessage": "Erstelle Flüge und weise Standort zu. Bitte warten...",
      "itemName": "Flug"
    },
    "sampleFile": {
      "header": "Kennzeichen\tAnkunftsdatum\tAbflugdatum"
    },
    "errors": {
      "noActiveFBO": "Kein aktives FBO ausgewählt",
      "noValidTrips": "Keine gültigen Trips vorhanden",
      "missingAircraftData": "Trips können nicht ohne Flugzeugdaten hochgeladen werden. Bitte wähle Flugzeuge aus für: {{tailNumbers}}",
      "failedTenantSearch": "Suche nach Mandant fehlgeschlagen: {{message}}",
      "missingAircraftId": "Interner Fehler: Flug ohne aircraft_id für {{tailNumber}} – sollte durch Validierung abgefangen werden",
      "failedTenantCreate": "Mandant konnte nicht erstellt werden: {{message}}",
      "assignmentFailed": "{{tailNumber}}: Trip erstellt, aber Zuweisung fehlgeschlagen – {{message}}",
      "unknownError": "Unbekannter Fehler",
      "tripCreationFailed": "{{tailNumber}}: {{message}}",
      "saveFailed": "Speichern fehlgeschlagen. Bitte nochmal versuchen."
    },
    "success": {
      "allSucceeded": "✓ {{count}} Flug{{locationMessage}} erfolgreich hinzugefügt",
      "partialSuccess": "✓ {{successCount}} von {{totalCount}} Trips erfolgreich hinzugefügt{{locationMessage}}.\n\n✗ {{failedCount}} fehlgeschlagen:\n{{errors}}",
      "allFailed": "✗ Keine Flüge hinzugefügt:\n{{errors}}"
    },
    "successState": {
      "dialogTitle": "Upload abgeschlossen",
      "title": "Flüge erfolgreich erstellt",
      "message": "{{count}} Flug(e) wurden dem Flugplan hinzugefügt.",
      "assignedTo": "Zugewiesen an {{locationName}}.",
      "viewTrips": "Flüge anzeigen",
      "done": "Fertig"
    }
  },
  "tripDetailsModal": {
    "title": "Flugdetails",
    "buttons": {
      "newTrip": "Neuer Flug",
      "view": "Zeigen",
      "edit": "Ändern",
      "close": "Schließen",
      "cancelTrip": "Flug stornieren",
      "deleteTrip": "Flug löschen",
      "assignToLocation": "Standort zuweisen",
      "save": "Speichern",
      "saving": "Speichert...",
      "deleting": "Löschen...",
      "cancelling": "Wird abgebrochen...",
      "cancel": "Abbrechen",
      "keepTrip": "Flug behalten"
    },
    "labels": {
      "tailNumber": "Kennzeichen",
      "ownerManager": "Inhaber/Manager",
      "aircraft": "Flugzeug",
      "arrival": "Ankunft",
      "departure": "Abflug",
      "duration": "Dauer",
      "notes": "Notizen",
      "locationHistory": "Standortverlauf",
      "tripNavigation": "Flugnavigation"
    },
    "placeholders": {
      "ownerManager": "Eigentümer- oder Managername eingeben",
      "notes": "Notizen...",
      "unknown": "Unbekannt",
      "noNotes": "Keine Notiz",
      "unassigned": "Nicht zugew."
    },
    "chips": {
      "transient": "Durchreisend"
    },
    "duration": {
      "indefinite": "Unbefristet",
      "days": "{{days}}T {{hours}}Std {{minutes}}Min",
      "hours": "{{hours}}h {{minutes}}m",
      "minutes": "{{minutes}} Min."
    },
    "tableHeaders": {
      "location": "Standort",
      "arrival": "Ankunft",
      "departure": "Abflug",
      "duration": "Dauer"
    },
    "navigation": {
      "previous": "Zurück: {{dates}}",
      "next": "Weiter: {{dates}}",
      "noOtherTrips": "Keine weiteren Flüge"
    },
    "confirmations": {
      "deleteTitle": "Flug löschen",
      "deleteMessage": "Möchtest du diesen Flug für {{tailNumber}} wirklich dauerhaft löschen? Diese Aktion kann nicht rückgängig gemacht werden und entfernt den gesamten Platzierungsverlauf.",
      "cancelTitle": "Flug abbrechen",
      "cancelMessage": "Möchtest du diesen Flug für {{tailNumber}} wirklich stornieren? Der Flugstatus wird auf Storniert gesetzt und kann nicht einfach rückgängig gemacht werden."
    },
    "tooltips": {
      "unassigned": "Das Flugzeug ist in diesem Zeitraum keinem bestimmten Hangar oder Abstellplatz zugewiesen. Es befindet sich möglicherweise auf einem Transitparkplatz oder wartet auf eine Platzzuweisung."
    }
  },
  "aircraftTripsModal": {
    "title": "Flüge für {{tailNumber}}",
    "emptyState": {
      "title": "Keine Flüge gefunden",
      "description": "Dieses Flugzeug hat noch keine geplanten Flüge."
    },
    "tripCount": "Zeigt {{count}} Flug an",
    "clickToView": "Flug anklicken für Details",
    "viewingTrip": "Flug für {{tailNumber}} anzeigen",
    "duration": {
      "daysAndHours": "{{days}} Tag, {{hours}} Std.",
      "hoursAndMinutes": "{{hours}} Std., {{minutes}} Min.",
      "minutes": "{{minutes}} Min."
    },
    "tripDetails": {
      "title": "Flugdetails",
      "editTooltip": "Bearbeiten",
      "unknown": "Unbekannt",
      "labels": {
        "aircraft": "Flugzeug",
        "arrival": "Ankunft",
        "departure": "Abflug",
        "duration": "Dauer",
        "notes": "Notizen"
      }
    }
  },
  "scheduleListPage": {
    "alerts": {
      "selectFBO": "FBO auswählen"
    },
    "buttons": {
      "createFirstTrip": "Ersten Flug erstellen",
      "createTrip": "Flug erstellen",
      "timelineView": "Zeitleistenansicht"
    },
    "emptyState": {
      "description": "Beschreibung",
      "title": "Keine Einträge"
    },
    "title": "Zeitplanübersicht"
  }
}
